import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { PopularCaseList } from '@/components/modules/List/Popular/PopularCase';
import { PopularConsultantList } from '@/components/modules/List/Popular/PopularConsultantList';
import { WeeklyRankingList } from '@/components/modules/List/Popular/WeeklyRankingList';
/**
 * バナー広告、記事の週間ランキング、人気のコンサルタント、人気の選定支援事例を表示するためのコンポーネント
 * @param props
 * @returns
 */
export const SideMenuPopular = (props) => {
    const { bannerComponent, className, isGuestUser, isLoadingPopularCase, isLoadingPopularConsultant, isLoadingWeeklyRankingList, isProfessionalUser, onClickRegistration, popularCases, popularConsultantList, popularConsultantListHasMoreLink, weeklyRankingList, weeklyRankingListLimit, weeklyRankingMoreLink, } = props;
    const isShowPopularConsultant = useMemo(() => {
        if (isProfessionalUser) {
            return false;
        }
        return (isGuestUser ||
            typeof popularConsultantList === 'undefined' ||
            isLoadingPopularConsultant ||
            popularConsultantList.length > 0);
    }, [
        isGuestUser,
        isLoadingPopularConsultant,
        isProfessionalUser,
        popularConsultantList,
    ]);
    return (_jsxs("div", Object.assign({ className: clsx(className, 'flex', 'flex-col', 'gap-32') }, { children: [bannerComponent, _jsx(WeeklyRankingList, { items: weeklyRankingList, loading: !weeklyRankingList || isLoadingWeeklyRankingList, maxDisplayCount: weeklyRankingListLimit, moreLink: weeklyRankingMoreLink }), isShowPopularConsultant && (_jsx(PopularConsultantList, { isGuestUser: isGuestUser, items: popularConsultantList, loading: !popularConsultantList || isLoadingPopularConsultant, moreLink: popularConsultantListHasMoreLink, onClickRegistration: onClickRegistration })), _jsx(PopularCaseList, { cases: popularCases, loading: !popularCases || isLoadingPopularCase })] })));
};
